import { dataUserCombined } from 'dls-icons-data'
import { createIcon } from '../common'

const IconUserCombined = /*#__PURE__*/createIcon(dataUserCombined)
export default IconUserCombined
